import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Recupera o token do localStorage
    const token = localStorage.getItem('authTokenLicitaAdmin');

    // Verifica se o token existe
    if (token) {
      // Se o token existe, clona a requisição e adiciona o cabeçalho de autorização
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // Passa a requisição modificada para frente
    return next.handle(request);
  }
}
